import styles from "./LogoBar.module.css"

export default function LogoBar() {
    return(
        <div className={styles.logoBarContainer}>
            <img className={styles.logoBarContainerImg} src="/progdata-logo.png" alt="progdatalogo" />
        </div>
    )
}